import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SessionService } from '../../services/session/session.service';
import { ActivatedRoute } from '@angular/router';
import { ApprovalService } from '../../services/approval/approval.service';

@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.scss'],
  providers: [ApprovalService]

})
export class ApprovalComponent implements OnInit {
  subscription;
  approval_message;
  @ViewChild('jobs_section') jobs_section: ElementRef;

  constructor(private activated_route: ActivatedRoute, private approval_service: ApprovalService) { }

  ngOnInit() {
    this.approval_service.getApproval(this.activated_route.snapshot.params.req_res_id, this.activated_route.snapshot.params.user_id, this.activated_route.snapshot.params.status).subscribe(res => {

      if (res['message']) {
        this.approval_message = res['message'];


        if (!this.approval_message) {
          this.jobs_section['innerHTML'] = `<h4 class="card-title text-center m-0">
            No Jobs!
            </h4>`
        }
      }
    });
  }
  ngAfterViewInit() {
    this.jobs_section.nativeElement.innerHTML = '<img src="/assets/loader.gif">'
  }

}
